// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z74g","content":"styles_content__222Pv","tableWrap":"styles_tableWrap__rpLgc"};